<!--
 * @Description: 
 * @Date: 2021-07-26 21:15:53
-->
<template>
  <div @click="toYsh" v-if="showToYsh">
    <p>查看</p>
    <p>更多视频</p>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'ToYsh',
  computed: {
    showToYsh() {
      return this.$store.state.channel.isVisitYsh;
    }
  },
  methods: {
    toYsh() {
      location.href = `${config.ysh}&phone=${this.$store.state.user.info.phone}`;
    }
  }
};
</script>

<style scoped lang="scss">
div {
  width: 1.81rem;
  height: 1.81rem;
  background: linear-gradient(180deg, #62cff8 0%, #0879e9 100%);
  box-shadow: -0.08rem 0.08rem 0.27rem 0px rgba(52, 168, 250, 0.56);
  border-radius: 0.91rem;
  position: absolute;
  right: 0.43rem;
  bottom: 2.43rem;
  text-align: center;
  color: #fff;
  // display: flex;
  // flex-wrap: wrap;
  p:first-child {
    margin-top: 0.3rem;
  }
}
</style>
